export const SPLIT_CLIENT_FAILED = 'SPLIT_CLIENT_FAILED';
export const SPLIT_CLIENT_READY = 'SPLIT_CLIENT_READY';
export const SPLITS_FETCHED = 'SPLITS_FETCHED';
